export const USER_NAMESPACE = 'users' as 'users'

export const USER = {
  CREATE: 'createUsers' as 'createUsers',
  UPDATE: 'updateUsers' as 'updateUsers',
  UPDATE_STATUS: 'updateUsersStatus' as 'updateUsersStatus',
  DELETE: 'deleteUsers' as 'deleteUsers',
}
